import { render } from "./bannerNoticeAdd.vue?vue&type=template&id=4c35a75a&scoped=true"
import script from "./bannerNoticeAdd.vue?vue&type=script&lang=js"
export * from "./bannerNoticeAdd.vue?vue&type=script&lang=js"

import "./bannerNoticeAdd.vue?vue&type=style&index=0&id=4c35a75a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c35a75a"]])

export default __exports__